import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import notification from "common/utils/notification"
import { useTranslation } from "react-i18next"
import { UpdateDatosRegistroMercantilProps } from "./Commands/UpdateEmpresaConfiguracionRegistroMercantil"
import {
  deleteEmpresaLogo,
  getEmpresaConfiguracionRegistroMercantilById,
  putEmpresaConfiguracionRegistroMercantilById,
  putEmpresaLogo,
} from "./Empresa.service"

export function useUpdateEmpresaActivaLogo() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const invalidateEmpresaActiva = () =>
    queryClient.invalidateQueries({ queryKey: ["getUsuarioEmpresaActiva"] })
  const { mutateAsync: updateLogoMutation, isPending: updateLogoIsLoading } =
    useMutation({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mutationFn: async (queryParams: $TSMigrationFixMe) => {
        putEmpresaLogo(queryParams).then(() => invalidateEmpresaActiva())
      },
      onSuccess: () =>
        notification.success({
          body: `${t("notification.logoCorrectlyUpdate")}`,
        }),
    })
  const { mutateAsync: deleteLogoMutation, isPending: deleteLogoIsLoading } =
    useMutation({
      mutationFn: async () =>
        deleteEmpresaLogo().then(() => invalidateEmpresaActiva()),
      onSuccess: () =>
        notification.success({
          body: `${t("notification.logoCorrectlyDelete")}`,
        }),
    })

  return {
    updateLogoIsLoading,
    updateLogoMutation,
    deleteLogoIsLoading,
    deleteLogoMutation,
  }
}

export function useRegistroMercantil(empresaActivaId?: string) {
  const queryClient = useQueryClient()
  const {
    data: activeCompanyRegistroMercantil,
    isLoading: activeCompanyRegistroMercantilIsLoading,
    error: activeCompanyRegistroMercantilError,
  } = useQuery({
    queryKey: ["getRegistroMercantil", empresaActivaId],
    queryFn: () =>
      empresaActivaId &&
      getEmpresaConfiguracionRegistroMercantilById(empresaActivaId),
    refetchOnWindowFocus: false,
    retry: false,
  })
  const activeCompanyRegistroMercantilInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getRegistroMercantil"] })

  const { mutateAsync: activeCompanyRegistroMercantilMutation } = useMutation({
    mutationFn: async (queryParams: UpdateDatosRegistroMercantilProps) =>
      putEmpresaConfiguracionRegistroMercantilById(queryParams).then(() => {
        activeCompanyRegistroMercantilInvalidation()
      }),
  })

  return {
    activeCompanyRegistroMercantil,
    activeCompanyRegistroMercantilIsLoading,
    activeCompanyRegistroMercantilError,
    activeCompanyRegistroMercantilInvalidation,
    activeCompanyRegistroMercantilMutation,
  }
}
